import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/_athlete/programs")({
  component: RouteComponent,
  staticData: {
    getBreadcrumb() {
      return {
        href: "/programs",
        labelTranslationKey: "programs",
      };
    },
  },
});

function RouteComponent() {
  return <Outlet />;
}
